export const UPDATE_TICKET_STATUS_ACTION="UPDATE_TICKET_STATUS_ACTION"
export const TICKET_ESCALATE_ACTION="TICKET_ESCALATE_ACTION"